import { Divider, Empty } from 'antd'
import styled from 'styled-components'
import { PrimaryButton } from './Button'
import { LikeOutlined } from '@ant-design/icons'
import { useState } from 'react'

export const ScreenHeight = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
`

export const FlexBox = styled.div`
  display: flex;
`

export const FlexRow = styled(FlexBox)`
  flex-direction: row;
  align-items: center;
  &.deadline-row p {
    margin-bottom: 0.5rem !important;
  }
  &.deadline-row h6 {
    padding-left: 5px;
    font-size: 14px;
  }
  & strong {
    font-family: 'roboto';
  }
`
export const FlexColumn = styled(FlexBox)`
  flex-direction: column;
`
export const FlexRowBetween = styled(FlexRow)`
  justify-content: space-between;
`
export const Line = styled.div`
  width: 100%;
  height: 2px;
  background: #e7eaf9;
  border: solid 0.5px #e7eaf9;
`
export const FlexRowWrap = styled(FlexRow)`
  flex-wrap: wrap;
`

export const ImageContainer = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  ${({ round }) => round && 'border-radius: 50%;'}
`

export const PriceStyle = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  color: #0fca98;
`

export const CardTitle = styled.h3`
  margin: 5px 0;
  font-weight: 700;
`

export const CardLocation = styled.p`
  margin: 0;
  color: #4e5c79;
`

export const CardGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 10px;
  padding: 0px 100px;
  gap: 16px; /* Add spacing between the cards */
  @media (max-width: 600px) {
    padding: 0px 20px;
  }
`

export const CardWrapper = styled.div`
  width: 100%;
  max-width: 300px; /* Limit the card width */
  margin-bottom: 16px; /* Bottom margin for spacing */

  @media (max-width: 1200px) {
    width: 30%;
  }

  @media (max-width: 992px) {
    width: 45%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const PropertyBlockWrap = styled.div`
  background: white;
  border-radius: 8px;
  margin-top: 20px;
`

export const PropertyBlockTitle = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  margin-bottom: 10px;
`

export const NoDataFound = () => {
  return <Empty />
}

const ContainerForm = styled.div`
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 35px;
  background-color: ${({ theme }) => theme.colors.white};
`

const Title = styled.h4`
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: 600;
`

export const PersonInformation = ({
  children,
  title,
  handleButtonClick,
  showButton,
  buttonTitle,
}) => {
  return (
    <ContainerForm>
      <div className="d-flex justify-content-between">
        <Title>{title}</Title>
        {showButton && (
          <PrimaryButton onClick={handleButtonClick}>
            Add {buttonTitle}
          </PrimaryButton>
        )}
      </div>
      <Divider />
      {children}
    </ContainerForm>
  )
}

export const PageContainer = styled.div`
  .ant-upload-list-item-container {
    display: none;
  }
  .error {
    color: #ff4d4f;
  }
`
const getTextColor = rank => {
  switch (rank) {
    case 1:
      return '#D4AF37' // Gold
    case 2:
      return '#A6A6A6' // Silver
    case 3:
      return '#CD7F32' // Bronze
    default:
      return '#1A1A1A' // Default dark color
  }
}

const Badge = styled.span`
  font-weight: bold;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  ${({ type }) => type === 'votes' && `background-color: white !important;`}
  color: ${({ rank, type }) =>
    type === 'views' ? getTextColor(rank) : getTextColor(rank)};
`

export const RankBadge = ({ rank, type, value }) => {
  return (
    <Badge rank={rank} type={type}>
      {type === 'votes' ? (
        <span>
          <LikeOutlined /> {value}
        </span>
      ) : (
        <span>{rank !== null ? `#${rank}` : '-'}</span>
      )}
    </Badge>
  )
}

export const VideoCardContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const ImageLoad = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setIsLoaded(true)}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'filter 0.4s ease-out',
        filter: isLoaded ? 'blur(0px)' : 'blur(20px)',
      }}
    />
  )
}
